import type { Language } from './../enums/language';
import PowerduckState from '../../app/powerduck-state';

export default class LanguageTranslator {
	static getString(lang: Language | Language) {
		return PowerduckState.getResourceValue(`language${lang?.toUpperCase()}` as any);
	}
}
